import { ELCLogger, TriggerType } from '@estee/elc-logging';
export class PerformanceMarker {
    private readonly logger: ELCLogger;
    private readonly serviceViewName: string;

    constructor(logger: ELCLogger, name: string) {
        this.logger = logger;
        this.serviceViewName = name;
    }

    startMark = (name: string) => {
        try {
            performance.mark(`${this.serviceViewName}_${name}`);
        } catch (error) {
            this.logger.error({
                message: `[${this.serviceViewName}]: ${error}`,
                triggerType: TriggerType.other,
                payload: {
                    error
                }
            });
        }
    };

    endMark = (name: string) => {
        try {
            if (performance.getEntriesByName(name)) {
                const markName = `${this.serviceViewName}_${name}`;
                performance.mark(`${markName}_end`);
                performance.measure(
                    `${this.serviceViewName}_measure_${name}`,
                    `${markName}`,
                    `${markName}_end`
                );
                this.clearMark(markName);
            }
        } catch (error) {
            this.logger.error({
                message: `[${this.serviceViewName}]: ${error}`,
                triggerType: TriggerType.other,
                payload: {
                    error
                }
            });
        }
    };

    // Chrome has a limit of markers that it can support at the same time
    // In order to limit the amount of markers we'll clean everything except the mesure one after we take the mesurements
    clearMark = (name: string) => {
        performance.clearMarks(name);
        performance.clearMarks(`${name}_end`);
    };
}
